import { ACTION_AUTHEN_VERIFY_TOKEN, ACTION_AUTHEN_VERIFY_TOKEN_ERROR, ACTION_AUTHEN_VERIFY_TOKEN_SUCCESS } from "."
import * as api from "../../../api"

export const verifyTokenRequest = (access_token, appInfo, url) => ({
    type: ACTION_AUTHEN_VERIFY_TOKEN,
    payload: {
        access_token,
        appInfo,
        url
    }
})

export const verifyTokenSuccess = data => ({
    type: ACTION_AUTHEN_VERIFY_TOKEN_SUCCESS,
    payload: {
        data
    }
})


export const verifyTokenError = msg => ({
    type: ACTION_AUTHEN_VERIFY_TOKEN_ERROR,
    payload: {
        msg
    }
})

export const verifyToken = (access_token, appInfo, url) => {
    return dispatch => {
        dispatch(verifyTokenRequest(access_token, appInfo, url))
        api.verifyToken(access_token, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(verifyTokenError("error"));
                    return
                }
                dispatch(verifyTokenSuccess({
                    app: appInfo, 
                    data: {
                        userid: data.userid,
                        username: data.username,
                        chip: data.ag,
                        vip: data.vip,
                        ref: data.ref,
                        extras: data.extras,

                    }
                }));
            }).catch((err) => {

                console.log(err)

                dispatch(verifyTokenError("system error"))
            });
    }
}